import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import formatName from 'I18n/utils/formatName';
import { Flex } from 'foundations-components/components/Flex';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import { jsx as _jsx } from "react/jsx-runtime";
const SummaryHeaderOwnedBy = ({
  documentId,
  documentMetadata
}) => {
  var _documentAnalyticsSum;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const userREST = documentMetadata.get('user');
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const userCHIRP = (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.user) || null;
  const user = isUngatedToChirp ? userCHIRP : userREST;
  const ownerName = isUngatedToChirp ? userCHIRP && formatName(userCHIRP) : userREST && formatName(userREST.toObject());
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    justifyContent: "end",
    flexGrow: 0,
    flexShrink: 0,
    marginInlineEnd: "300",
    paddingBlock: "100",
    children: /*#__PURE__*/_jsx("span", {
      "data-vr-display-none": true,
      "data-test-id": "summary-header-owned-by",
      children: user && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "summary.header.owner",
        options: {
          owner: ownerName
        }
      })
    })
  });
};
export default SummaryHeaderOwnedBy;